document.addEventListener('change', function (event) {
  var select = event.target.closest('[data-variant-select]');
  if (!select) return;
  var option = select.options[select.selectedIndex];
  var scope = select.closest('section') || document;
  var price = scope.querySelector('[data-price]');
  var compare = scope.querySelector('[data-compare]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (compare) {
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
  }
});


// DIAGX hero 3D: keep the model on its clean front/three-quarter angles.
// This gives a premium 3D motion without ever exposing the unreliable AI-generated back mesh.
(function () {
  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupRock(model) {
    if (!model || model.dataset.diagxReady === '1') return;
    model.dataset.diagxReady = '1';

    let userInteracting = false;
    let resumeTimer = null;
    const maxAngle = 18; // degrees: deliberately stays on front/3-quarter views
    const speedSetting = Math.max(2, Math.min(18, Number(model.dataset.rockSpeed || 7)));
    const periodMs = 24000 / (speedSetting / 7);
    const start = performance.now();

    function pauseForUser() {
      userInteracting = true;
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => { userInteracting = false; }, 3500);
    }

    ['pointerdown','touchstart','mousedown','wheel'].forEach(evt => {
      model.addEventListener(evt, pauseForUser, { passive: true });
    });

    function tick(now) {
      if (!prefersReduced && !userInteracting && model.isConnected) {
        const phase = ((now - start) % periodMs) / periodMs * Math.PI * 2;
        const theta = Math.sin(phase) * maxAngle;
        model.cameraOrbit = `${theta.toFixed(2)}deg 75deg 110%`;
      }
      if (model.isConnected) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function boot() {
    document.querySelectorAll('model-viewer[data-diagx-rock]').forEach(setupRock);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
document.addEventListener('DOMContentLoaded', function () {

  const countdown = document.getElementById('diagx-countdown');

  if (!countdown) return;

  /*
    MODIFIE UNIQUEMENT CETTE DATE.
    Exemple :
    3 septembre 2026 à 23h59 heure française.
  */

  const endDate = new Date('2026-09-03T23:59:59+02:00').getTime();

  function updateCountdown() {

    const now = new Date().getTime();
    const distance = endDate - now;

    if (distance <= 0) {
      countdown.innerHTML = 'OFFRE TERMINÉE';
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));

    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24))
      / (1000 * 60 * 60)
    );

    const minutes = Math.floor(
      (distance % (1000 * 60 * 60))
      / (1000 * 60)
    );

    const seconds = Math.floor(
      (distance % (1000 * 60))
      / 1000
    );

    if (days > 0) {
      countdown.innerHTML =
        days + 'j ' +
        hours.toString().padStart(2,'0') + ':' +
        minutes.toString().padStart(2,'0') + ':' +
        seconds.toString().padStart(2,'0');
    } else {
      countdown.innerHTML =
        hours.toString().padStart(2,'0') + ':' +
        minutes.toString().padStart(2,'0') + ':' +
        seconds.toString().padStart(2,'0');
    }
  }

  updateCountdown();

  setInterval(updateCountdown, 1000);

});